export const TEST_ID = 'flightPathIcon';
